export const ROUTE_INTRO = 'intro';
export const ROUTE_GENDER = 'gender';
export const ROUTE_AGE = 'age';
export const ROUTE_BIRTHDAY = 'birthday';
export const ROUTE_READY = 'ready';
export const ROUTE_SIZE = 'size';
export const ROUTE_FINISH = 'finish';



// WEBPACK FOOTER //
// ./src/containers/fitting/RouteList.ts